import { useQuery } from '@tanstack/react-query';
import { kpiApi } from '../lib/api.js';
import { queryKeys } from '../lib/query-keys.js';

/**
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business acm_records（日次4ブロック25指標）を期間指定で取得するフック。表/CSV用。
 * @graph-connects kpiApi [calls] acm_records API client
 * @graph-connects queryKeys [calls] Query key factory
 */
export function useAcmRecords(from?: string, to?: string) {
  return useQuery({
    queryKey: queryKeys.kpi.records(from, to),
    queryFn: () => kpiApi.getRecords({ from, to }),
    staleTime: 5 * 60_000,
    retry: false,
  });
}
